import React from 'react';
import { Field } from 'redux-form';
import SelectComponentField from '../SelectComponentField/SelectComponentField';
import PropTypes from 'prop-types';

var SelectComponent = function SelectComponent(_ref) {
  var id = _ref.id,
      values = _ref.values,
      label = _ref.label,
      validate = _ref.validate,
      displayNotes = _ref.displayNotes,
      handleChange = _ref.handleChange,
      placeholder = _ref.placeholder,
      language = _ref.language;

  if (!Array.isArray(values)) {
    return null;
  }

  return React.createElement(Field, {
    name: id,
    component: SelectComponentField,
    label: label,
    className: 'form-control',
    validate: validate,
    values: values,
    displayNotes: displayNotes,
    handleChange: handleChange,
    placeholder: placeholder,
    language: language
  });
};

SelectComponent.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.object.isRequired,
  values: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
  validate: PropTypes.array,
  handleChange: PropTypes.func.isRequired,
  displayNotes: PropTypes.string,
  language: PropTypes.string,
  placeholder: PropTypes.string
};
export default SelectComponent;